// Tiny, dependency-free helpers: the storefront needs them without loading the (lazy) tour UI itself.
/** Client mirror after server save; v3 base — append user id in Catalog for per-account keys. */
export const CATALOG_STUDIO_TOUR_STORAGE_KEY = "catalogStudioGuidedTour_v3";

export function isCatalogStudioTourCompletedLocally(storageKey = CATALOG_STUDIO_TOUR_STORAGE_KEY) {
  try {
    return localStorage.getItem(storageKey) === "1";
  } catch {
    return false;
  }
}

export function markCatalogStudioTourCompletedLocally(storageKey = CATALOG_STUDIO_TOUR_STORAGE_KEY) {
  try {
    localStorage.setItem(storageKey, "1");
  } catch {
    /* ignore */
  }
}
